import { render, staticRenderFns } from "./DocumentsFilters.vue?vue&type=template&id=5f3b107e"
import script from "./DocumentsFilters.vue?vue&type=script&lang=js"
export * from "./DocumentsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports